// exposes node_modules/jquery
import $ from 'jquery';
window['$'] = $;
